<template>
  <div class="panel panel-default">
    <div class="panel-heading">Retirar Cashback</div>
    <div class="panel-body">
      <div class="clearfix mb-10">Atual: <strong>{{ cashback | brlPrice }}</strong></div>
      <form
        @submit.prevent="handleSubmit"
        ref="form"
        name="company-cashback">
        <div class="col-xs-6 padding-off">
          <money
            v-model="form.cashback"
            v-bind="money"
            v-validate="'required|min_value:1'"
            :class="{ 'alert-danger': submitted && errors.has('cashback') }"
            name="cashback"
            class="form-control"></money>
            <span
              v-if="submitted && errors.has('cashback')"
              class="theme-form-error-message">{{ errors.first('cashback') }}</span>
        </div>
        <div class="col-xs-6 _pr-0">
          <button
            :disabled="loading"
            type="submit"
            class="btn-blue btn-block btn-small">
            Atualizar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'

export default {
  components: {
    Money
  },
  props: [
    'cashback',
    'loading'
  ],
  data () {
    return {
      submitted: false,
      form: {
        cashback: 0
      },
      money: {
        decimal: ',',
        thousands: '.',
        // prefix: 'R$ ',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    handleForm (cashback) {
      this.form.cashback = cashback
    },
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.$emit('handleAction', 'postAdminCompanyUpdateCashback', this.form)
          this.form.cashback = 0
          this.$validator.clean()
        }
      }).catch(() => {
        this.submitted = false
      })
    }
  }
}
</script>
